export const URL = "https://keyug.com/api/";
export const BASE_URL = "https://keyug.com/uploads/";

// export const URL = "http://localhost:5000/api/";
// export const BASE_URL = "http://localhost:5000/";
